export default {
  NEXT_PAGE: "VOTING_FORM_NEXT_PAGE",
  SET_CURRENT_PAGE: "VOTING_FORM_SET_CURRENT_PAGE",
  TOGGLE_MODAL: "VOTING_FORM_TOGGLE_MODAL",
  PREVIOUS_PAGE: "VOTING_FORM_PREVIOUS_PAGE",
  RESET_MODAL_STATE: "VOTING_FORM_RESET_MODAL_STATE",
};
